export { LANGUAGE_FILTER_ALL } from '@/shared/config';

export const TEMPLATE_LIST_PARAM = {
  language: 'language',
  specialty: 'specialty',
} as const;

// 192px = 12rem at the 16px root font size
export const NAME_COLUMN_MIN_WIDTH = 192;
export const NAME_COLUMN_MAX_WIDTH = 800;
